import axios from 'axios'
import { Dispatch, SetStateAction } from 'react'
import 'regenerator-runtime/runtime'

const messages = {
    erreur: "connexion impossible"
}

class Postier{

    getPays(setPays){
        const url = "https://countriesnow.space/api/v0.1/countries/flag/images"

        fetch(url).then(res=>{
            return res.json().then(response=>{
                setPays(response.data)
            })
        }).catch(err=>{
            console.log({err})
        })
    }

    getSite(token:string,client:string,site:string,setSite, setErrors: Dispatch<SetStateAction<string[]>>){
        axios.get(`api-v0/${client.split(":")[0]}/${site.split(':')[0]}`,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setSite(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, `Les données du site ${site} ne peuvent pas être récupérées`])
            localStorage.clear()
            // location.reload()
        })

    }

    updateSite(token: string, client: string, data, setPage, setErrors: Dispatch<SetStateAction<string[]>>, database: string){
        axios.post(`api-v0/update/${client.split(":")[0]}?database=${database}`,data,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                const result = res.data

                if (result.ID === data.ID){
                    setErrors((errors: string[]) => [...errors, "Modification réussie"])
                    setPage("main")
                    location.reload()
                } else{
                    setErrors((errors: string[]) => [...errors, "Une erreur est survenue lors de la transaction"])
                }
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "Échec lors de la modification du site"])
        })

    }

    createSite(token: string, data, setPage, setErrors: Dispatch<SetStateAction<string[]>>) {
        axios.post(`api-v0/site/create`,data,{headers:{ Authorization: `Bearer ${token}` }})
        .then(res=>{
            if (res.data) {
                setErrors((errors: string[]) => [...errors, "Le site a été créé"])
                setPage("site");
                localStorage.setItem('site', res.data.ID + ':'  + res.data.Name)
                location.reload();
            }
    }).catch(err=>{
        setErrors((errors: string[]) => [...errors, "Le site ne peut pas être créé"])
    }) 
    } 


}

export const postier = new Postier()